import { useSelector } from 'react-redux';
import { Fragment, useEffect, useState } from 'react';
import { Box, CircularProgress, Grid, Pagination, Paper, Typography, styled } from '@mui/material';
import { store } from '../store';
import { getExpirationList, getExpirations, statusExpiration } from '../features/expirations/expirationsSlice';
import ExpirationItem from './ExpirationItem';

const Border = styled(Paper)(({ theme }) => ({
  border: '1px solid',
  borderColor: theme.palette.grey[300],
  padding: '1rem 2rem',
}));

const List = styled(Box)(({ theme }) => ({
  maxWidth: '100%',
  display: 'row',

  [theme.breakpoints.up('md')]: {
    display: 'grid',
    columnGap: '1rem',
    rowGap: '.5rem',
    gridTemplateColumns: 'minmax(1rem, 3fr) minmax(6rem, 9fr) minmax(5rem, 8fr) 8fr 5fr minmax(6rem, 12rem)',
  },
}));

interface SeparatorProps {
  row: number;
}

const Separator = styled(Box, {
  shouldForwardProp: prop => prop !== 'row',
})<SeparatorProps>(({ theme, row }) => ({
  border: '1px dashed rgba(166, 166, 166, 0.2)',
  gridRow: (row + 1) * 2,
  gridColumn: '1/8',
  height: '2px',
  marginBottom: '.5rem',
  marginTop: '.5rem',

  [theme.breakpoints.up('md')]: {
    marginBottom: 0,
    marginTop: 0,
  },
}));

export default function ExpirationList() {
  const expirations = useSelector(getExpirationList);
  const status = useSelector(statusExpiration);

  const [expirationPage, setExpirationPage] = useState(1);

  useEffect(() => {
    store.dispatch(getExpirations(expirationPage));
  }, [expirationPage]);

  return (
    <Border>
      <Grid container direction="column">
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="subtitle1" mb={1} mr={2}>
            Mis Vencimientos
          </Typography>
          {
            status === 'loading'
              ? <CircularProgress size={20} />
              : null
          }
        </Box>
        {
          expirations?.vencimientos
            ? expirations.vencimientos.length == 0
              ? <Typography>No hay vencimientos para mostrar</Typography>
              : <>
                  <List>
                    {
                      expirations.vencimientos.map((expiration, i) => (
                        <Fragment key={
                          `${
                            expiration.imponible.tipo
                          }-${
                            expiration.imponible.imponible
                          }-${
                            expiration.recurso.numero }`
                        }>
                          <ExpirationItem
                            expiration={expiration}
                            row={i * 2 + 1}
                          />
                          {
                            i + 1 < expirations.vencimientos.length
                              ? <Separator row={ i } />
                              : null
                          }
                        </Fragment>
                      ))
                    }
                  </List>
                  <Pagination
                    sx={{ alignSelf: 'center', marginTop: '1rem' }}
                    count={ expirations?.paginacion.total }
                    size="small"
                    onChange={(_, value: number) => setExpirationPage(value)}
                    variant="outlined"
                    color="primary"
                    shape="rounded"
                  />
                </>
            : null
        }
      </Grid>
    </Border>
  );
}
